@if (url(); as avatarUrl) {
    <picture class="mho-avatar" [class.rounded]="rounded()">
        <img [src]="avatarUrl" alt="" (error)="onError()"/>
    </picture>
}
